/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_S4_TitleInputs */

const en_landing_guide_s4_title = /** @type {(inputs: Landing_Guide_S4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompting tips for Ideogram 4.5`)
};

const zh_landing_guide_s4_title = /** @type {(inputs: Landing_Guide_S4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 4.5 提示词技巧`)
};

/**
* | output |
* | --- |
* | "Prompting tips for Ideogram 4.5" |
*
* @param {Landing_Guide_S4_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_s4_title = /** @type {((inputs?: Landing_Guide_S4_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_S4_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_s4_title(inputs)
	return zh_landing_guide_s4_title(inputs)
});
export { landing_guide_s4_title as "landing.guide.s4_title" }